var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7485 9.9996L13.7485 9.9996",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7485 3H17.2485C17.713 3 17.9452 3 18.1401 3.02567C19.4863 3.2029 20.5456 4.26222 20.7229 5.60842C20.7485 5.80337 20.7485 6.03558 20.7485 6.5",
    stroke: "#00AA5B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75146 6.95014C2.75146 6.06761 2.75146 5.62635 2.82081 5.25878C3.12611 3.64071 4.39177 2.37504 6.00985 2.06975C6.37742 2.0004 6.81868 2.0004 7.70121 2.0004C8.08789 2.0004 8.28123 2.0004 8.46704 2.01777C9.26812 2.09268 10.028 2.40743 10.6474 2.92091C10.7911 3.04001 10.9278 3.17672 11.2012 3.45014L11.7515 4.0004C12.5672 4.81618 12.9751 5.22407 13.4636 5.49582C13.7319 5.64511 14.0165 5.763 14.3118 5.84717C14.8494 6.0004 15.4262 6.0004 16.5799 6.0004H16.9536C19.5859 6.0004 20.9021 6.0004 21.7576 6.76986C21.8363 6.84064 21.9112 6.91553 21.982 6.99423C22.7515 7.84975 22.7515 9.16593 22.7515 11.7983V14.0004C22.7515 17.7716 22.7515 19.6572 21.5799 20.8288C20.4083 22.0004 18.5227 22.0004 14.7515 22.0004H10.7515C6.98023 22.0004 5.09461 22.0004 3.92304 20.8288C2.75146 19.6572 2.75146 17.7716 2.75146 14.0004V6.95014Z",
    stroke: "#00AA5B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.a08861c08648150f02af46ea65e343f5.svg";
export { ForwardRef as ReactComponent };